"use client";
import { jsx as e } from "react/jsx-runtime";
import { memo as t } from "react";
import i from "../components/Icon/SvgIcon.js";
const r = (o) => /* @__PURE__ */ e(
  i,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4.5h15.991v2.399H4zm0 6.269h15.991v2.398H4zM19.991 17.1H4v2.4h15.991z",
        clipRule: "evenodd"
      }
    )
  }
), n = t(r);
export {
  n as SearchListView,
  n as default
};
